import React from 'react';
import errorReporter from '@app/errorReporter';
import styled from 'styled-components';
import { Text } from '@bb/elements-web';
import { ContactDrawerMode, ContactDrawerType } from '../../contexts';

const StyledButton = styled.button`
  width: max-content;
`;

export interface AgentChatLinkProps {
  agentId?: string;
  firstName: string;
  lastName?: string;
  openContactDrawer: (
    mode: ContactDrawerMode,
    type: ContactDrawerType,
    id?: string,
  ) => void;
}

const AgentChatLink: React.FC<AgentChatLinkProps> = ({
  agentId,
  firstName,
  lastName,
  openContactDrawer,
}) => {
  const chatLink = React.useRef<HTMLButtonElement>(null);

  const handleClick = React.useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();

      if (!openContactDrawer) {
        errorReporter.error(
          'Agent chat link was pressed but no callback was provided',
        );
      } else {
        openContactDrawer(
          ContactDrawerMode.Profile,
          ContactDrawerType.User,
          agentId,
        );
      }
    },
    [agentId, openContactDrawer],
  );

  /* Changed from onClick to eventListener due to bubbling resulting 
  in the listing page opening instead of the Agent Drawer */
  React.useEffect(() => {
    const element = chatLink.current;

    if (element) {
      element.addEventListener('click', handleClick);
    }

    return () => {
      if (element) element.removeEventListener('click', handleClick);
    };
  }, [handleClick]);

  if (!agentId) {
    return (
      <div>
        {firstName} {lastName || ''}
      </div>
    );
  }

  return (
    <StyledButton className="btn btn-link chat-link" ref={chatLink}>
      <Text color="primary" thickness="bold">
        {firstName} {lastName || ''} <i className="fa fa-envelope" />
      </Text>
    </StyledButton>
  );
};

export default AgentChatLink;
